export default "__VITE_ASSET__R6mc$7l3__"